/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {createSelector} from '@reduxjs/toolkit';

import {selectGeneralSettings} from '../generalSettings/selectors';

const selectSlice = createSelector(selectGeneralSettings, (state) => state?.documentSeries);

export const selectSeries = createSelector(selectSlice, (state) => state.series);
